module.exports = __webpack_public_path__ + "static/media/logo-dekton.d1d378df.jpg";